__turbopack_context__.v({
  "container": "t6AZ-q_container",
  "cta": "t6AZ-q_cta",
  "description": "t6AZ-q_description",
  "desktopChart": "t6AZ-q_desktopChart",
  "input": "t6AZ-q_input",
  "inputs": "t6AZ-q_inputs",
  "mobileChart": "t6AZ-q_mobileChart",
  "suggestedPercentages": "t6AZ-q_suggestedPercentages",
  "wrapper": "t6AZ-q_wrapper",
});
